<template>
  <form
    :disabled="loading"
    @submit="handleSubmit"
  >
    <Stack>
      <Stack
        gap="1"
      >
        <Label>Title</Label>

        <FormText
          v-model="localForm.title"
          type="text"
          required
        />
      </Stack>

      <Stack gap="1">
        <Label>Prompt</Label>

        <FormText
          v-model="localForm.prompt"
          type="textarea"
          required
        />
      </Stack>

      <Stack gap="1">
        <Label>Enabled?</Label>

        <Toggle
          v-model="localForm.enabled"
        />
      </Stack>

      <Stack gap="1">
        <Label>Frequency</Label>

        <CronPicker
          :cron="localForm.cron"
          @change="handleCronChange"
        />
      </Stack>

      <Stack gap="1">
        <Label>Recipients</Label>

        <FormList
          v-model="localForm.recipients"
          type="email"
        />
      </Stack>

      <Buttons>
        <Button
          variant="primary"
          :disabled="loading"
        >
          Save Changes
        </Button>
      </Buttons>
    </Stack>
  </form>
</template>

<script setup>
import { defineEmits, reactive, watch } from 'vue';
import { Button, Buttons, Label, Stack, FormList, FormText, Toggle } from '@stakeui';
import CronPicker from './CronPicker.vue';

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['submit']);

const localForm = reactive({
  title: props.form.title || '',
  prompt: props.form.prompt || '',
  cron: props.form.cron || '',
  recipients: props.form.recipients || [],
  enabled: props.form.enabled || true,
});

const handleCronChange = ({ cron: newCron }) => {
  if (newCron === localForm.cron) return;
  localForm.cron = newCron;
};

// Sync when parent form changes (e.g. job was fetched later)
watch(
    () => props.form,
    newVal => {
      if (!newVal) return;
      localForm.title = newVal.title || '';
      localForm.prompt = newVal.prompt || '';
      localForm.cron = newVal.cron || '';
      localForm.recipients = newVal.recipients || [];
      localForm.enabled = newVal.enabled || true;
    },
    { deep: true },
);

const handleSubmit = event => {
  event.preventDefault();

  emit('submit', {
    title: localForm.title,
    prompt: localForm.prompt,
    cron: localForm.cron,
    recipients: localForm.recipients,
    enabled: localForm.enabled,
  });
}
</script>
